import { useTranslation } from '@conekta/cronos/i18n';
import { getXprops } from 'app/helpers/getXprops';
import { truncateString } from 'app/util/strings';
import { useContext } from 'react';
import { DefaultTheme, ThemeContext } from 'styled-components';

import { ParagraphMethod } from '../styled-components/ParagraphMerchant';

const T_ROOT = 'bnplInformation';

const BnplInformation = () => {
  const { t } = useTranslation();

  const THEME_CONTEXT: DefaultTheme = useContext(ThemeContext);
  const { font } = THEME_CONTEXT.colors;

  const {
    options: {
      paymentMethodInformation: { bnplText = '' },
    },
  } = getXprops();

  return <ParagraphMethod color={font}>{bnplText ? truncateString(bnplText) : t(`${T_ROOT}.text`)}</ParagraphMethod>;
};

export default BnplInformation;
